import { observer } from "mobx-react-lite"
import { CheckboxCard } from "shared/ui/CheckboxCard"
import { ScheduleEventStore } from "../../app/store"

// ----------------------------------------------------------------------

export const ScheduleTypeToggler = observer(function ScheduleTypeToggler() {
  const { toggleType, professionOnly, isLoading } = ScheduleEventStore

  const onChange = (checked: boolean) => toggleType(checked)

  return (
    <CheckboxCard
      title="Показать только профессии"
      description="Большие учебные программы с кураторской поддержкой и экзаменационной работой для освоения новой специальности с нуля"
      checked={professionOnly}
      onChange={onChange}
      disabled={isLoading}
    />
  )
})
